export const routes = (prefix = `inventory-management`) => [
    {
        path: `/${prefix}/stock-level-perstore`,
        name: `${prefix}.stock-level-perstore.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-level-perstore.index`,
                PageDescription: "Inventory management: Stock Level per Store",
            },
        },
    },
    {
        path: `/${prefix}/stock-level-perstorefilter`,
        name: `${prefix}.stock-level-perstore.indexfilter`,
        component: () => import('./IndexFilters.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.stock-level-perstore.index`,
                PageDescription: "Inventory management: Stock Level per Store",
            },
        },
    },
    
];
